import { Component } from "@angular/core";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ActivatedRoute, Params, Router } from "@angular/router";

import { AfterViewInit, ViewChild } from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";

import { merge, Observable, of as observableOf } from "rxjs";
import { catchError, map, startWith, switchMap } from "rxjs/operators";
import { Compte } from "../core/model/compte";
import { CompteService } from "../core/service/compte.service";
import { Employee } from "src/app/parametrage/core/model/employee/employee";
import { EmployeeService } from "src/app/parametrage/core/service/employee.service";

@Component({
  selector: "app-compte-by-gestionnaire",
  templateUrl: "./compte-by-gestionnaire.component.html",
  styleUrls: ["./compte-by-gestionnaire.component.scss"],
})
export class CompteByGestionnaireComponent implements AfterViewInit {
  dossiers: Compte[];

  displayedColumns: string[] = [
    "codeClient",
    "typeClient",
    "nomClient",
    "codeAgentEconomique",
    "segmentationClient",
    "status",
  ];

  resultsLength = 0;
  isLoadingResults = true;
  isRateLimitReached = false;

  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;

  currentEmployee: Employee = new Employee();

  constructor(
    private modalService: NgbModal,
    private _router: Router,
    private _compteService: CompteService,
    private _employeeService: EmployeeService
  ) {
    this.getCurrentEmployee();
  }

  ngAfterViewInit() {}

  getCurrentEmployee() {
    this._employeeService.getCurrentEmployee().subscribe(
      (data) => {
        this.currentEmployee = data;
        this.getPageCompte("_", 0);
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getPageCompte(filter: String, pageIndex: number): void {
    // If the user changes the sort order, reset back to the first page.
    this.sort.sortChange.subscribe(
      () => (this.paginator.pageIndex = pageIndex)
    );

    merge(this.sort.sortChange, this.paginator.page)
      .pipe(
        startWith({}),
        switchMap(() => {
          this.isLoadingResults = true;

          return this._compteService.findAllPagingGestionnaire(
            filter,
            this.currentEmployee.codeAgent,
            this.paginator.pageIndex,
            this.paginator.pageSize,
            this.sort.active,
            this.sort.direction
          );
        }),
        map((data) => {
          // Flip flag to show that loading has finished.
          this.isLoadingResults = false;
          this.isRateLimitReached = false;
          this.resultsLength = data.totalElements;

          return data.content;
        }),
        catchError(() => {
          this.isLoadingResults = false;
          // Catch if the GitHub API has reached its rate limit. Return empty data.
          this.isRateLimitReached = true;
          return observableOf([]);
        })
      )
      .subscribe((data) => (this.dossiers = data));
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.getPageCompte(filterValue, 0);
  }

  voirDetailCompte(codeClient): void {
    this._router.navigate(["/suivi-portefeuille/detail-compte/" + codeClient]);
  }
}
